<template>
  <div class="flex flex-col">
    <el-descriptions label-class-name="desc-label" class="description" :column="3" border>
      <el-descriptions-item label="药库编码">
        {{ pageData.prescription.head['positionCode'] }}
      </el-descriptions-item>
      <el-descriptions-item label="药库名称">
        {{ pageData.prescription.head['positionName'] }}
      </el-descriptions-item>
    </el-descriptions>
    <el-table
      :stripe="true"
      :border="true"
      :data="pageData.prescription.body.medPrescriptionItem"
      class="ik-list-table"
      height="300"
      :header-row-class-name="'ik-list-table-header-row'"
      :header-cell-class-name="'ik-list-table-header-cell'"
      :row-class-name="'ik-list-table-body-row'"
      :cell-class-name="'ik-list-table-body-cell'"
      :highlight-current-row="true"
    >
      <el-table-column
        align="center"
        label="药品编码"
        prop="materielName"
      />
      <el-table-column
        prop="materielName"
        label="药品名称"
        align="center"
      />
      <el-table-column prop="sellingNum" label="数量" align="center" />
      <el-table-column
        prop="medAdvice"
        label="医嘱"
        align="center"
      />
      <el-table-column
        prop="salePrice"
        label="单价"
        align="center"
      />
      <el-table-column
        prop="saleAmount"
        label="总价"
        align="center"
      />
    </el-table>
  </div>
</template>
<script>

export default {
  name: "PrescriptionInfo",
  inject: ["pageData"],
  filters: {
    SERVE_FEE_SIGN(sign) {
      switch (sign) {
        case "00":
          return "不加工"
        case "01":
          return "代煎"
        case "11":
          return "制粒"
        case "21":
          return "细粉打粉"
        case "22":
          return "粗粉打粉"
        case "31":
          return "水丸制丸"
        case "32":
          return "蜜丸制丸"
        case "33":
          return "大蜜丸制丸"
        case "35":
          return "水蜜丸制丸"
        case "41":
          return "制瓶装膏"
        case "42":
          return "制袋装膏"
        case "43":
          return "制块装膏"
      }
    },
    /**
     * 质量标识
     * @param sign
     * @returns {string}
     * @constructor
     */
    QUALITY_SIGN(sign) {
      switch (sign) {
        case "1":
          return "普通"
        case "2":
          return "精品"
        default:
          return ""
      }
    }
  }
}
</script>

<style scoped lang="scss">
.description {
  margin-bottom: 20px;
}

::v-deep .desc-label {
  width: 120px;
}
</style>
